import {isNullOrUndefined} from '@/utils'

const MoneyFormat = {
  /**
   * 功能描述：格式化金额字段
   * 使用方式
   * {{item.bidAmount | moneyFormat}}
   *
   * @param number 金额
   * @param minimumFractionDigits
   * @returns {string}
   */
  moneyFormat (number, minimumFractionDigits = 2) {
    if (!isNullOrUndefined(number)) {
      if (typeof number === 'string' && number.includes(',')) {
        number = number.replaceAll(',', '')
      }
      const value = Number(number)
      const options = {
        style: 'currency',
        currency: 'CNY',
        minimumFractionDigits
      }
      let res = (value).toLocaleString('zh-CN', options)
      if (res) {
        res = res.replace('¥', '')
      }
      return res
    }
    // number = number || 0
    // places = !isNaN(places = Math.abs(places)) ? places : 2
    // symbol = symbol !== undefined ? symbol : ''
    // thousand = thousand || ','
    // decimal = decimal || '.'
    // let negative = number < 0 ? '-' : ''
    // let i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + ''
    // let j = i.length > 3 ? i.length % 3 : 0
    // return symbol + negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : '')
  },

  // 全局安装器
  install (Vue) {
    Vue.filter('moneyFormat', this.moneyFormat)
  }
}

export default MoneyFormat



// WEBPACK FOOTER //
// ./src/filters/money-format.js